import {useMemo} from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './PriceBlock.module.scss';
import React from 'react';
import Capsules, {buildCapsules} from 'js/components/shared/Capsules';
import {sanitizeContent} from 'js/shared/security';

const cx = classnames.bind(styles);

const PriceBlock = (props) => {
  const {
    align = 'left',
    info,
    discountTooltipText,
    priceHelperText,
    priceOldHelperText,
    priceColor,
    capsules,
    discount,
    breakfast,
    shortVersion = false,
    memberPrice,
    publicPrice,
    defaultPrice,
    className
  } = props;

  const topPrice = useMemo(() => {
    return {
      price: memberPrice?.price || defaultPrice?.price,
      priceColor: memberPrice?.priceColor || priceColor,
      crossedPrice: memberPrice?.oldPrice || (shortVersion ? defaultPrice?.oldPrice : null),
    }
  }, [memberPrice, defaultPrice]);

  const botPrice = useMemo(() => {
    if (shortVersion) return null;

    return {
      price: publicPrice?.price || defaultPrice?.oldPrice,
      crossedPrice: publicPrice?.oldPrice,
    }
  }, [publicPrice, defaultPrice])

  const allCapsules = useMemo(
    () => buildCapsules(capsules, {discount, breakfast}),
    [capsules, discount, breakfast],
  );

  const hasDiscount = !!discount?.length;

  const isMemberPrice =!!memberPrice?.price;

  return (
    <div className={cx('root', align, className)}>
      <Capsules
        capsules={allCapsules}
        discountTooltipText={discountTooltipText}
        align={align}
      />
      <p className={cx('price')}>
        { priceHelperText && (
          <span className={cx('description')}>
            {priceHelperText}
          </span>
        )}
        {topPrice.crossedPrice && (
          <span className={cx('crossed', {highlighted: isMemberPrice})} dangerouslySetInnerHTML={{__html: sanitizeContent(topPrice.crossedPrice)}} />
        )}
        <span
          className={cx('amount', {discount: hasDiscount})}
          style={{color: topPrice.priceColor}}
          dangerouslySetInnerHTML={{__html: sanitizeContent(topPrice.price)}}
        />
      </p>
      { botPrice?.price && (
        <p className={cx('public-price')}>
          <span className={cx('description')}>{priceOldHelperText}</span>
          {botPrice.crossedPrice && (
            <span className={cx('crossed')} dangerouslySetInnerHTML={{__html: sanitizeContent(botPrice.crossedPrice)}} />
          )}
          <span className={cx('amount')} dangerouslySetInnerHTML={{__html: sanitizeContent(botPrice.price)}} />
        </p>
      )}
      {info && (
        <p className={cx('price-info')}>{info}</p>
      )}
    </div>
  )
}

PriceBlock.propTypes = {
  className: PropTypes.string,
  align: PropTypes.oneOf(['left', 'right']),
}

export default PriceBlock;
